// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__Dib9e","consentsList":"PatientConsents_consentsList__obyeG","consentsListEmpty":"PatientConsents_consentsListEmpty__2w92D"};